import { gql } from "@apollo/client";

const BASKETBALL_STATS = gql`
  query fixture($id: ID!) {
    fixture(id: $id) {
      id
      event {
        id
        sport {
          id
          name
          statTypeGroups {
            id
            name
            types {
              id
              name
            }
          }
        }
      }
      metas {
        id
        label
        value
        stringValue
      }
      periods {
        id
        label
      }
      placements {
        id
        value
        organization {
          id
          name
        }
      }
      statTables {
        id
        order
        organization {
          id
        }
        profile {
          id
          name
          profilePhoto {
            id
            filename
          }
        }
        statType {
          id
          name
        }
        value
      }
      statsSummary {
        participantId
        fga1
        fgm1
        fga2
        fgm2
        fga3
        fgm3
        fta
        ftm
        blocks
        points
        offensiveRebounds
        defensiveRebounds
        assists
        steals
        turnovers
        foulsBasketball
      }
      stats {
        id
        createdAt
        timeStamp
        value
        stringValue
        statType {
          id
          name
        }
        profile {
          id
          name
        }
        organization {
          id
          name
        }
        fixturePeriod {
          id
          order
          label
        }
        relationshipsFrom {
          id
          to {
            id
            createdAt
            stringValue
            timeStamp
            statType {
              id
              name
            }
            profile {
              id
              name
            }
            organization {
              id
              name
            }
            fixturePeriod {
              id
              order
              label
            }
            value
          }
        }
        relationshipsTo {
          id
          from {
            id
            createdAt
            stringValue
            timeStamp
            statType {
              id
              name
            }
            profile {
              id
              name
            }
            organization {
              id
              name
            }
            fixturePeriod {
              id
              order
              label
            }
            value
          }
        }
      }
    }
  }
`;

export default BASKETBALL_STATS;
